/**
 * Shows an element once and will set a cookie to prevent showing it again for a chosen amount of days
 * @param {string} id selector id of the element
 * @param {number} days amount of days until shown again
 */
const showElementOnce = function (id, days) {
    if (!document.cookie.includes(id)) {
        document.getElementById(id).classList.remove('hidden');
        setCookie(id, "{{ encrypt('1') }}", days);
    }
};

function setCookie(key, value, days) {
    var daysInt = parseInt(days);
    var expires = new Date();
    expires.setTime(expires.getTime() + daysInt * 24 * 60 * 60 * 1000);
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}

export { showElementOnce };
